import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { PuffLoader } from 'react-spinners';
import { Elements, useStripe, useElements, CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { IconButton } from '@mui/material';
import { InfoIcon } from 'lucide-react';

import AppLayout from 'Components/layout/AppLayout';
import BackButton from 'Components/common/button/BackButton';
import LoadingSpinner from 'Components/common/loading/LoadingSpinner';
import { AcceptOfferApi, buyPackPaymentSuccessCall, GetOfferPaymentPreviewApi, MakePaymentBrand } from 'actions/chatActions';
import LightTooltip from 'Components/common/LightToolTip';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const PaymentForm = () => {

  console.log({
    stripePromise: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.substring(0, 10)
  });

  const { loadingBrandPayment } = useSelector((state) => state.chat);


  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation();

  const [packId, setPackId] = useState(null);

  const [collabOfferId, setCollabOfferId] = useState(null);

  const userToken = useState(localStorage.getItem("token"));
  const {
    currentChatId
  } = useSelector((state) => state.chat)
  useEffect(() => {
    setPackId(location?.state?.pack_id)
    setCollabOfferId(location?.state?.offer_id)
  }, [location])

  const stripe = useStripe();
  const elements = useElements();
  const [paymentError, setPaymentError] = useState('');
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  //
  const [preview, setPreview] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(true);

  const fee = preview?.display?.processing_fee;   // số fee đã tính
  const total = preview?.display?.total;          // total người dùng phải trả

  // const labelTooltip = `
  //     Processing fee applied to this payment.

  //     Platform fee + Stripe fee:
  //     ${(fee)} added to the total.
  //     `;


  const collabOffer = location?.state?.collaboration_offer;

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    if (!preview) {
      setPaymentError('Payment amount not ready yet.');
      return;
    }

    console.log("location?.state?.payment_type: ", location?.state?.payment_type);

    // CAMPAIGN COLLABORATION
    if (location?.state?.payment_type === "campaign_collaboration_offer") {
      try {

        setPaymentError('');
        const { token, error } = await stripe.createToken(
          elements.getElement(CardNumberElement)
        );

        if (error) {
          setPaymentError(error);
          //
          setPaymentLoader(false);
        } else {
          try {
            let formData = {};
            formData.offer_id = collabOfferId;
            formData.token = token.id;
            let header = {
              Authorization: `Bearer ${userToken[0]}`,
            };
            let response = await dispatch(AcceptOfferApi({ header, formData, dispatch, currentChatId }));
            if (response.error) {
              toast.error(response?.payload?.error);
              setPaymentLoader(false);
            } else {
              setPaymentSuccess(true);
              toast.success('Payment made successfully');
              navigate('/creatorChat');
            }
          } catch (error) {
            setPaymentLoader(false);
            toast.error(error?.response?.data?.error);
          }
        }
      } catch (error) {
        setPaymentError("An error occurred during payment processing.");
      }
    } else if (location?.state?.payment_type === "buy_pack") {
      try {

        setPaymentError('');
        const { token, error } = await stripe.createToken(
          elements.getElement(CardNumberElement)
        );

        if (error) {
          setPaymentError(error);
          //
          setPaymentLoader(false);
        } else {
          try {
            let data = {};
            data.pack_proposal_id = packId;
            data.token = token.id;
            let header = {
              Authorization: `Bearer ${userToken[0]}`,
            };
            let response = await dispatch(buyPackPaymentSuccessCall({ header, data, dispatch, currentChatId }));
            if (response.error) {
              toast.error(response?.payload?.error);
              setPaymentLoader(false);
            } else {
              setPaymentSuccess(true);
              toast.success('Pack bought successfully');
              navigate('/creatorChat');
            }
          } catch (error) {
            //
            setPaymentLoader(false);
            toast.error(error?.response?.payload?.error);
          }
        }
      } catch (error) {
        //
        setPaymentLoader(false);
        setPaymentError("An error occurred during payment processing.");
      }
    } else {
      // INVITE COLLABORATION 
      try {
        // location?.state?.payment_type ===  invite_collaboration_offer
        setPaymentError('');
        const { token, error } = await stripe.createToken(
          elements.getElement(CardNumberElement)
        );
        if (error) {
          setPaymentError(error);
          //
          setPaymentLoader(false);
        } else {
          try {
            let formData = {};
            formData.offer_id = collabOfferId;
            formData.token = token.id;
            let header = {
              Authorization: `Bearer ${userToken[0]}`,
            };
            let response = await dispatch(MakePaymentBrand({ header, formData, dispatch, currentChatId }));
            if (response.error) {
              toast.error(response?.payload?.error);
              setPaymentLoader(false);
            } else {
              setPaymentSuccess(true);
              toast.success('Payment made successfully');
              // navigate('/creatorChat');
              navigate('/creatorChat', { state: { openFirstChat: true } });
            }
          } catch (error) {
            //
            setPaymentLoader(false);
            toast.error(error?.response?.payload?.error);
          }
        }
      } catch (error) {
        setPaymentError("An error occurred during payment processing.");
      }
    }
  };

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const header = {
          Authorization: `Bearer ${userToken[0]}`,
        };
        const res = await dispatch(
          GetOfferPaymentPreviewApi({ header, offerId: location?.state?.offer_id })
        );

        if (!res.error) {
          setPreview(res.payload); // preview = res.payload từ BE
        }
      } catch (e) {
        console.error("Error fetching payment preview", e);
        toast.error("Error fetching payment preview");
      } finally {
        setLoadingPreview(false);
      }
    };

    if (location?.state?.offer_id && userToken?.[0]) {
      fetchPreview();
    }
  }, [location?.state?.offer_id]);

  return (
    <AppLayout>
      <div className='container sm:tw-p-[20px]'>
        <BackButton
          onClick={() => {
            const previousPage = location?.state?.from
            navigate(previousPage);
          }}
        />
      </div>
      {loadingPreview && (
        <LoadingSpinner />
      )}
      {preview &&
        <div className='payment-container-box sm:tw-p-12 tw-w-min-[90vw] sm:tw-min-w-min'>
          <div className="tw-flex tw-content-between tw-items-center tw-flex-wrap tw-mb-6">
            <h2 className='tw-block tw-w-full sm:tw-w-1/2'>Make a Payment</h2>
            <div className='text-muted fs-4 tw-w-full sm:tw-w-1/2 sm:tw-text-right tw-pl-0'>

              <span className='tw-text-[#63abad] tw-mr-2 tw-font-bold'>
                {preview.display?.total} </span>
              for {collabOffer?.object}

              <LightTooltip
                //  placement="right"
                title={<div className="tw-space-y-1">
                  <div>Processing fee applied to this payment.</div>

                  <div>Stripe fee:</div>

                  <div>{fee} added to the total.</div>
                </div>}
              >
                <IconButton size="small">
                  <InfoIcon width="18" height="18" />
                </IconButton>
              </LightTooltip>

            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <label className="tw-mb-3">
              Card Details
            </label>

            <div className="--payment-section tw-mb-4 tw-grid tw-grid-cols-12 sm:tw-grid-cols-12 tw-gap-4">
              {/* Card Number */}
              <div className="tw-col-span-12">
                <div className="tw-py-3 stripe-input-design">
                  <CardNumberElement />
                </div>
                <div className="tw-ml-3">
                  {paymentError.code === "incomplete_number"
                    ? <p className="tw-text-red-500">{paymentError.message}</p>
                    : <p></p>}
                </div>
              </div>

              {/* CVC */}
              <div className="tw-col-span-12 sm:tw-col-span-6">
                <div className="tw-py-3 stripe-input-design">
                  <CardCvcElement />
                </div>
                <div className="tw-ml-3">
                  {paymentError.code === "incomplete_cvc"
                    ? <p className="tw-text-red-500">{paymentError.message}</p>
                    : <p></p>}
                </div>
              </div>

              {/* Expiry */}
              <div className="tw-col-span-12 sm:tw-col-span-6">
                <div className="tw-py-3 stripe-input-design">
                  <CardExpiryElement />
                </div>
                <div className="tw-ml-3">
                  {paymentError.code === "incomplete_expiry"
                    ? <p className="tw-text-red-500">{paymentError.message}</p>
                    : <p></p>}
                </div>
              </div>

            </div>

            <div className='tw-flex tw-content-end'>
              <button onClick={() => {
                if (paymentSuccess) {
                  setPaymentSuccess(false);
                  setPaymentError("");
                }
                setPaymentLoader(true);
              }} className='tw-btn-gradient tw-w-full sm:tw-max-w-[120px] sm:tw-ml-auto' type="submit" disabled={!stripe}>
                {loadingBrandPayment || paymentLoader ? (
                  <PuffLoader
                    className="tw-content-center tw-m-auto"
                    color="white"
                    size={22}
                  />
                ) : (
                  "Pay"
                )}
              </button>
            </div>
            {paymentSuccess && <p style={{ color: 'green' }}>Payment successful!</p>}
          </form>
        </div>
      }
    </AppLayout>
  );
};

const WrappedPaymentForm = () => (
  <Elements stripe={stripePromise}>
    <PaymentForm />
  </Elements>
);

export default WrappedPaymentForm;
